<template>
  <div class="card main_bg text-black">
    <h1 class="card-header subHeader">Breaking News</h1>
    <div
      class="news-scroll"
      style="height: 550px; overflow-y: scroll"
      tabindex="0"
      role="region"
      aria-label="Breaking news, scrollable"
    >
      <div v-for="(item, i) in news" :key="i" class="card mt-2 news-card">
        <div class="card-header">
          <router-link
            class="news-title-link"
            :to="'/news/breaking-news#' + item.id"
            v-text="stripHtml(item.title)"
          ></router-link>
          <div>[{{ item.date }}]</div>
        </div>
        <div class="card-body" v-html="item.content"></div>
      </div>
    </div>
    <div class="card-footer social-container">
      <a
        href="https://www.facebook.com/tairnews"
        target="_blank"
        class="social-icon"
        aria-label="Facebook"
        tabindex="0"
      >
        <i class="fab fa-facebook" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCqYlBTnoVz6s1beB058lBqQ"
        target="_blank"
        class="social-icon"
        aria-label="YouTube"
        tabindex="0"
      >
        <i class="fab fa-youtube" aria-hidden="true"></i>
      </a>
      <a
        href="https://bsky.app/profile/tairnews.bsky.social"
        target="_blank"
        class="social-icon"
        aria-label="Bluesky"
        tabindex="0"
      >
        <i class="fa-brands fa-bluesky" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.linkedin.com/company/phoenix-bioinformatics"
        target="_blank"
        class="social-icon"
        aria-label="LinkedIn"
        tabindex="0"
      >
        <i class="fab fa-linkedin" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</template>

<script>
import { getShortNews } from "@/services/NewsService";

export default {
  name: "BreakingNewsCard",
  data() {
    return {
      news: [],
    };
  },
  methods: {
    // Titles can contain Confluence hyperlinks; rendering them inside the
    // router-link would nest <a> elements, so show the plain text only.
    // DOMParser builds an inert document (no scripts run, no images load).
    stripHtml(html) {
      const doc = new DOMParser().parseFromString(html || "", "text/html");
      return doc.body.textContent.trim();
    },
  },
  mounted() {
    getShortNews()
      .then((response) => {
        this.news = response;
      })
      .catch((error) => {
        console.error("Error fetching news:", error);
      });
  },
};
</script>

<style scoped lang="scss">
.subHeader {
  font-size: 20px;
  font-weight: bold;
  color: black;
}
.main_bg {
  background-color: #fff;
}
.text-black {
  color: black;
}
.news-card {
  text-align: left;
}

/* Keyboard users need to see when the scroll area itself has focus */
.news-scroll:focus {
  outline: 3px solid #005fcc !important;
  outline-offset: -3px;
}

/* Block display so the focus outline wraps the whole title; bold replaces
   the <strong> formatting dropped when the title HTML is stripped */
.news-title-link {
  display: block;
  font-weight: bold;
}
.news-title-link:focus {
  outline: 2.5px solid #005fcc !important;
  outline-offset: 2px;
  background-color: #feffbb;
}

.social-container {
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: center;
}

.social-icon {
  color: #2c3e50;
  font-size: 1.6rem;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus {
    color: #1d6100;
    transform: scale(1.15);
  }
}
</style>
